import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { ConfirmPopupProvider } from '@UI/ConfirmPopup/ConfirmPopupProvider'

import { CallProvider } from '@context/CallContext'

import { App } from './App'
import './i18n'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import { store } from './store'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <ConfirmPopupProvider>
        {/* <CallProvider> */}
        <App />
        {/* </CallProvider> */}
      </ConfirmPopupProvider>
    </BrowserRouter>
  </Provider>,
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
